export default __webpack_public_path__ + "static/media/MSChat_Icon.a38a94ec.png";